import { Link } from "react-router-dom";

import { cn } from "@/lib/utils";

import {
  inboundContinueStationHref,
  inboundContinueStationLabel,
  type InboundContinuePlacement,
} from "./inboundContinuePath";

const TONE: Record<InboundContinuePlacement, string> = {
  waiting: "bg-slate-100 text-slate-800",
  holding: "bg-amber-100 text-amber-900",
  pending_put_away: "bg-sky-100 text-sky-900",
};

export function InboundContinueStationLink(props: {
  placement: InboundContinuePlacement;
  arrivalScan?: string | null;
  inventoryBoxHex?: string | null;
}): JSX.Element {
  return (
    <Link
      to={inboundContinueStationHref(props)}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold hover:underline",
        TONE[props.placement],
      )}
    >
      {inboundContinueStationLabel(props.placement)}
    </Link>
  );
}
